<template>
  <div class="layout">
    <div class="layout_nav">
      <Nav v-bind="getRol"></Nav>
    </div>
    <SkeletonDevice v-if="loadBar == true"></SkeletonDevice>
    <div v-else class="layout_center">
      <div class="layout_row">
        <div class="layout_colum">
          <Snackbar
            v-bind:visible="getAlert.snackbar"
            v-bind:text="getAlert.text"
          ></Snackbar>
        </div>
      </div>
      <div v-if="this.getQueyDevice != null">
        <div class="data_device_page">
          <div class="data_device_page_colum medium_35">
            <div class="data_device_map">
              <l-map :zoom="this.zoom" :center="coorde" class="style_map">
                <l-tile-layer :url="url" :attribution="attribution" />
                <l-marker :lat-lng="coorde">
                  <l-popup>
                    <div>
                      {{ getQueyDevice.nui }}
                      <div v-if = "getQueyDevice.typeDevice != 'Lora-Wan'">            
                        <span v-if="getQueyDevice.profile == 'post'"
                          >POSTPAGO</span
                        >
                        <span v-if="getQueyDevice.profile == 'pre'"
                          >PREPAGO</span
                        >
                      </div>
                    </div>
                  </l-popup>
                </l-marker>
              </l-map>
            </div>
          </div>
          <div class="data_device_page_colum">
            <div class="data_device_indicator px-6">
              <div class="item_indicator">
                <div>
                  <span class="device_active" v-if="getQueyDevice.activate == 1"
                    >Activo</span
                  >
                  <span class="device_inactive" v-else>Inactivo</span>
                </div>
                <div>
                  <span class="device_active" v-if="getQueyDevice.state == true"
                    >Conectado</span
                  >
                  <span class="device_inactive" v-else>Desconectado</span>
                </div>
              </div>
              <div class="item_indicator_battery">
                <span v-if="levelBattery == 100">
                  <v-icon>mdi-battery</v-icon>
                  {{levelBattery | battery}}%
                </span>
                <span v-else>
                  <v-icon style="color: #f50">mdi-battery-50</v-icon>
                  {{levelBattery | battery}}%
                </span>
              </div>
              <div class="item_indicator_actions">
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="table_menu"
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                    >
                      Acciones
                      <v-icon>mdi-menu-down</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item class="list_action">
                      <v-btn
                        class="on_line"
                        v-if="getQueyDevice.switch == false"
                        plain
                        @click="switchItem(getQueyDevice)"
                      >
                        <v-icon> mdi-power</v-icon>
                        <span>{{
                          getQueyDevice.subTypeService === "Energia"
                            ? "On"
                            : "Open"
                        }}</span>
                      </v-btn>
                      <v-btn
                        class="off_line"
                        v-else
                        plain
                        @click="switchItem(getQueyDevice)"
                      >
                        <v-icon> mdi-power</v-icon>
                        <span>{{
                          getQueyDevice.subTypeService === "Energia"
                            ? "Off"
                            : "Close"
                        }}</span>
                      </v-btn>
                    </v-list-item>
                   <!-- <v-list-item class="list_action">
                      <v-btn
                        class="cent"
                        @click="limitItem(getQueyDevice)"
                        plain
                        >CREAR LIMITE</v-btn
                      >
                    </v-list-item>
                    <v-list-item class="list_action">
                      <v-btn @click="scheduleItem(getQueyDevice)" plain>
                        <span>Programar</span>
                      </v-btn>
                    </v-list-item>
                    <v-list-item class="list_action">
                      <v-btn @click="takeItem(getQueyDevice)" plain>
                        <span>lectura</span>
                      </v-btn>
                    </v-list-item>
                    <v-list-item class="list_action">
                      <v-btn
                        class="cent"
                        @click="configItem(getQueyDevice)"
                        plain
                        >Configuración</v-btn
                      >
                    </v-list-item>
                    <v-list-item class="list_action">
                      <v-btn
                        v-if="getQueyDevice.state == true"
                        plain
                        @click="connectItem(getQueyDevice)"
                      >
                        <span>Deshabilitar</span>
                      </v-btn>
                      <v-btn v-else plain @click="connectItem(getQueyDevice)">
                        <span>Habilitar</span>
                      </v-btn>
                    </v-list-item> -->
                  </v-list>
                </v-menu>
              </div>
            </div> 
            <div class="indicator_num">
              <div class="ind_logo">
                <p>
                  <b>{{ getQueyDevice.idx }}</b>
                </p>
                <p v-if="getQueyDevice.subTypeService != 'Seguridad'">
                  <img src="../../assets/img/electric-meter_1.svg" alt="" />
                </p>
                <p v-else>
                  <img v-if="getQueyDevice.typeDeviceS == 'Sensor de Humo'" src="../../assets/img/detector-smoke.svg" alt="" />
                  <img  v-if="getQueyDevice.typeDeviceS == 'Sensor de Puerta'" src="../../assets/img/sensor-door.svg" alt="" />
                  <img  v-if="getQueyDevice.typeDeviceS == 'Boton de Panico'" src="../../assets/img/button_panic.svg" alt="" />
                </p>
                
                <p>
                  <b>{{ getQueyDevice.subTypeService }}</b>
                </p>
              </div>
              <div class="indicator_num_display _medium">
                <div class="">
                  <span v-if="getQueyDevice.profile == 'post'">POSTPAGO</span>
                  <span v-if="getQueyDevice.profile == 'pre'">PREPAGO</span>
                </div>
                <div v-if="getQueyDevice.subTypeService != 'Seguridad'"> 
                  <p>Lectura Medidor</p>
                  <p class="num_indi">{{ getQueyDevice.dataValue.v | threeDigit }}</p>
                </div>
                <div v-else> 
                  <p>Estado actual del dispositivo</p>
                  <p :class="'num_indi ' + getColorStyle">{{ getQueyDevice.dataValue.v | statusValueDevices(getQueyDevice.typeDeviceS)}}</p>
                </div>
                <p class="caption">{{ getQueyDevice.updateAt | formatDateFrom }}</p>
                <!--<div class="ctn_off_data">
                  <span
                    v-if="getQueyDevice.switch == true"
                    class="off_data online"
                    >{{
                      getQueyDevice.subTypeService === "Energia" ? "On" : "Open"
                    }}</span
                  >
                  <span v-else class="off_data offline">{{
                    getQueyDevice.subTypeService === "Energia"
                      ? "Off"
                      : "Closed"
                  }}</span>
                </div>-->
              </div>
              <div class="indicator_num _columns _medium">
                <v-tooltip left max-width="200px">
                  <template v-slot:activator="{ on, attrs }">
                    <div class="indicator_num_display _box" v-bind="attrs" v-on="on">
                      <p>Presionado rapido</p>
                        <p class="text_normal mb-0"  v-if="counter.length > 0">
                          {{counter[0]}}
                        </p>
                        <p v-else>
                          cargando...
                        </p>
                    </div>
                  </template>
                  <span style="max-width:50px;">Cantidad de presionados rapidos</span>
                </v-tooltip>
                <v-tooltip left max-width="200px">
                  <template v-slot:activator="{ on, attrs }">
                    <div class="indicator_num_display _box" v-bind="attrs" v-on="on">
                      <p>Presionado doble</p>
                      <p class="text_normal mb-0"  v-if="counter.length > 0">
                          {{counter[1]}}
                        </p>
                        <p v-else>
                          cargando...
                        </p>
                    </div>
                  </template>
                  <span style="max-width:50px;">Cantidad depresionados dobles</span>
                </v-tooltip>
                <v-tooltip left max-width="200px">
                  <template v-slot:activator="{ on, attrs }">
                    <div class="indicator_num_display _box" v-bind="attrs" v-on="on">
                      <p>Presionado constante</p>
                      <p class="text_normal mb-0"  v-if="counter.length > 0">
                          {{counter[2]}}
                        </p>
                        <p v-else>
                          cargando...
                        </p>
                    </div>
                  </template>
                  <span style="max-width:50px;">Cantidad de presionado constante</span>
                </v-tooltip>
              </div>
              <div class="indicator_num _columns _medium">
                <div class="indicator_num_display _box">
                  <p>Total de acciones</p>
                  <div>
                    <p class="text_normal"  v-if="counter.length > 0" >
                      {{total}}
                    </p>
                    <p v-else>
                      cargando...
                    </p>
                  </div>
                </div>
               <!-- <div class="indicator_num_display _box">
                  <p>Programado</p>
               </div>
                  <div
                    v-if="getQueyDevice.schedule != undefined"
                    class="indicator_itm"
                  >
                    <div
                      class="ctn_ind"
                      v-if="getQueyDevice.schedule.scheduledActive != false"
                    >
                      <p class="text_normal">
                        <span
                          class="device_active"
                          v-if="getQueyDevice.schedule.scheduledStatus == 'On'"
                          >{{
                            getQueyDevice.subTypeService === "Energia"
                              ? "On"
                              : "Open"
                          }}</span
                        >
                        <span class="device_inactive" v-else>{{
                          getQueyDevice.subTypeService === "Energia"
                            ? "Off"
                            : "Close"
                        }}</span>
                      </p>
                      <p class="text_normal">
                        {{ getQueyDevice.schedule.scheduledDate | formatDate }}
                      </p>
                      <v-btn @click="deleteScheduleItem(getQueyDevice)" small
                        >quitar</v-btn
                      >
                    </div>
                    <div style="width:100%" v-else>
                      <p class="text_normal text-left">Ninguno</p>
                    </div>
                  </div> 
                  <div style="width:100%" v-else>
                    <p class="text_normal text-left">Ninguno</p>
                  </div>
                </div>-->
              </div>
            </div>
            <div class="indicator_num">
              <div class="indicator_num_display _box _medium _movile">
                <div>
                  <p>NUI</p>
                  <p class="text_normal">{{ getQueyDevice.nui }}</p>
                </div>
                <div>
                  <p>Cód. Interno</p>
                  <p class="text_normal">{{ getQueyDevice.alternateCode }}</p>
                </div>
                <div>
                  <p>Estrato</p>
                  <p
                    v-if="getQueyDevice.socialgroup != undefined"
                    class="text_normal"
                  >
                    {{ getQueyDevice.socialgroup.name }}
                  </p>
                  <p v-else>-</p>
                </div>
                <div>
                  <p>Zona</p>
                  <p v-if="getQueyDevice.zone != undefined" class="text_normal">
                    {{ getQueyDevice.zone.name }}
                  </p>
                  <p v-else>-</p>
                </div>
                <div>
                  <p>Ruta</p>
                  <p v-if="getQueyDevice.road != undefined" class="text_normal">
                    {{ getQueyDevice.road.name }}
                  </p>
                  <p v-else>-</p>
                </div>
                <div>
                  <p>Ciclo</p>
                  <p
                    v-if="getQueyDevice.cycle != undefined"
                    class="text_normal"
                  >
                    {{ getQueyDevice.cycle.name }}
                  </p>
                  <p v-else>-</p>
                </div>
              </div>
              <div class="indicator_num_display _box _medium _movile">
                <div>
                  <p>Nombre</p>
                  <p class="text_normal">{{ getQueyDevice.customName }}</p>
                </div>
                <div>
                  <p>Serial</p>
                  <p class="text_normal">{{ getQueyDevice.serial }}</p>
                </div>
                <div>
                  <p>Fabricante</p>
                  <p class="text_normal">{{ getQueyDevice.manufacturer }}</p>
                </div>
                <div v-if="getQueyDevice.subTypeService === 'Gas'">
                  <p>Caudal</p>
                  <p class="text_normal">{{ getQueyDevice.gasFlow }}</p>
                </div>
                <div>
                  <p>Dispositivo</p>
                  <p class="text_normal">{{ getQueyDevice.deviceInfo.deviceName }}</p>
                </div>
                <div>
                  <p>NODO PADRE</p>
                  <p class="text_normal">{{ getQueyDevice.nodeID }}</p>
                </div>
                <div>
                  <p>POSICIÓN DE NODO</p>
                  <p class="text_normal">{{ getQueyDevice.childID }}</p>
                </div>
              </div>
              <div class="indicator_num_display _box _medium _movile">
                <div>
                  <p>Empresa</p>
                  <p
                    v-if="getQueyDevice.company != undefined"
                    class="text_normal"
                  >
                    {{ getQueyDevice.company.name }}
                  </p>
                  <p v-else>-</p>
                </div>
                <div>
                  <p>Dirección</p>
                  <p class="text_normal">{{ getQueyDevice.address }}</p>
                </div>
                <div>
                  <p>Ciudad</p>
                  <p class="text_normal">{{ getQueyDevice.city }}</p>
                </div>
                <div>
                  <p>Latitud</p>
                  <p class="text_normal">{{ getQueyDevice.latitude }}</p>
                </div>
                <div>
                  <p>Longitud</p>
                  <p class="text_normal">{{ getQueyDevice.longitude }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="section_sensor">
          <h4>Sensores Asociados</h4>
          <div class="child_sensor">
            <div
              class="indicator_num"
              v-for="item in getQueyNode.filter(
                (i) => i._id != getQueyDevice._id
              )"
              :key="item._id"
            >
              <div class="indicator_num_display _box">
                <p class="num_indi_date">idx {{ item.idx }}</p>
                <p>{{ item.deviceInfo.deviceName }}</p>
                <p class="text_normal">
                  {{ item.dataValue.v | threeDigit }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="section_graph">
          <div class="ctn_head_graph">
            <div class="head_title_graph">
              <h4>Grafico</h4>
            </div>
            <div class="head_indicator_graph">
              <v-btn
                v-bind:style="[
                  flagChart == 3
                    ? { 'background-color': '#06f', color: '#fff' }
                    : { 'background-color': 'transparent', color: '#000' },
                ]"
                @click="setChartRange"
                >PERSONALIZADO</v-btn
              >
              <v-btn
                v-bind:style="[
                  flagChart == 2
                    ? { 'background-color': '#06f', color: '#fff' }
                    : { 'background-color': 'transparent', color: '#000' },
                ]"
                @click="setChartYear"
                >AÑO</v-btn
              >
              <v-btn
                v-bind:style="[
                  flagChart == 1
                    ? { 'background-color': '#06f', color: '#fff' }
                    : { 'background-color': 'transparent', color: '#000' },
                ]"
                @click="setChartDay"
                >HOY</v-btn
              >
            </div>
          </div>
          <div></div>
        <div class="ctn_chart" v-if="flagChart == 1">
            <div v-if= "getQueyDevice.subTypeService != 'Seguridad'">
            <v-row>
              <v-col cols="12" sm="6" md="3">
                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="date"
                      label="Fecha"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      required
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    ref="date-picker"
                    v-model="date"
                    :max="new Date().toISOString().substr(0, 10)"
                    @input="menu2 = false"
                    @change="
                      actionDataChartDay({
                        _id: getQueyDevice._id,
                        date: date,
                      })
                    "
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <div class="ctn_flow_chart">
              <div class="flow_chart">
                <LineChart
                  :chartData="getDataChartDay"
                  :options="chartOptions"
                  label="Consumo"
                  :unit="getUnit"
                ></LineChart>
              </div>
            </div>
          </div>
          <div class="ctn_chart" v-else>
            <v-row>
              <v-col cols="12" sm="6" md="3">
                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="date"
                      label="Fecha"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      required
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    ref="date-picker"
                    v-model="date"
                    :max="new Date().toISOString().substr(0, 10)"
                    @input="menu2 = false"
                    @change="
                      actionDataSensorDay({
                        _id: getQueyDevice._id,
                        date: date,
                      })
                    "
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <div class="ctn_flow_chart">
              <div class="flow_chart">
                <LineChartButton
                  :chartData="getChartDataSensorDay"
                  :options="chartOptions"
                  label="Consumo"
                ></LineChartButton>
              </div>
            </div>
          </div>
        </div>

          <div class="ctn_chart" v-if="flagChart == 2">
            <div v-if= "getQueyDevice.subTypeService != 'Seguridad'">
            <v-row>
              <v-col cols="12" sm="6" md="3">
                <v-select
                  v-model="dateYear"
                  :items="inittahun"
                  label="Año"
                  @change="
                    actionDataChartYear({
                      _id: getQueyDevice._id,
                      date: dateYear,
                    })
                  "
                ></v-select>
              </v-col>
            </v-row>
            <div class="ctn_flow_chart">
              <div class="flow_chart">
                <LineChartYear
                  :chartData="getDataChartYear"
                  :options="chartOptionsYear"
                  label="Consumo"
                  :unit="getUnit"
                ></LineChartYear>
              </div>
            </div>
          </div>
          <div class="ctn_chart" v-else>
            <v-row>
              <v-col cols="12" sm="6" md="3">
                <v-select
                  v-model="dateYear"
                  :items="inittahun"
                  label="Año"
                  @change="actionDataSensorYear({
                      _id: getQueyDevice._id,
                      date: dateYear,
                    })
                  "
                ></v-select>
              </v-col>
            </v-row>
            <div class="ctn_flow_chart">
              <div class="flow_chart">
                <LineChartButtonYear
                  :chartData= "getChartDataSensorYear"
                  :options="chartOptions"
                  label="Consumo"
                ></LineChartButtonYear>
              </div>
            </div>
          </div>
          </div>
          <div class="ctn_chart" v-if="flagChart == 3">
            <div v-if= "getQueyDevice.subTypeService != 'Seguridad'">
             <v-row>
              <v-col cols="12" sm="6" md="3">
                <v-menu
                  ref="menuRange"
                  v-model="menuRange"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dateRangeText"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    ref="picker"
                    v-model="dateRange"
                    range
                    color="primary"
                    header-color="primary"
                    :max="new Date().toISOString().substr(0, 10)"
                    @change="
                      actionDataChartRange({
                        _id: getQueyDevice._id,
                        date: dateRange,
                      })
                    "
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <div class="ctn_flow_chart">
              <div class="flow_chart">
                <LineChartRange
                  :chartData="getDataChartRange"
                  :options="chartOptionsYear"
                  label="Consumo"
                  :unit="getUnit"
                ></LineChartRange>
              </div>
            </div>
          </div>
           <div class="ctn_chart" v-else>
            <v-row>
              <v-col cols="12" sm="6" md="3">
                <v-menu
                  ref="menuRange"
                  v-model="menuRange"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dateRangeText"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    ref="picker"
                    v-model="dateRange"
                    range
                    color="primary"
                    header-color="primary"
                    :max="new Date().toISOString().substr(0, 10)"
                    @change="
                      actionDataSensorRange({
                        _id: getQueyDevice._id,
                        date: dateRange,
                      })
                    "
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <div class="ctn_flow_chart">
              <div class="flow_chart">
                <LineChartButtonRange
                  :chartData= "getChartDataSensorRange"
                  :options="chartOptions"
                  label="Consumo"
                ></LineChartButtonRange>
              </div>
            </div>
           </div>      
      </div>
     </div>
        <div class="section_history">
          <h4>HISTORIAL</h4>
          <v-select
            class="tab_header_select"
            v-model="tab"
            :items="itemSelect"
            item-value="id"
            item-text="name"
            label="Opciones historico"
          ></v-select>
          <v-tabs class="tab_header_custom" v-model="tab">
           <!--  <v-tab key="1">Lecturas</v-tab> -->
            <v-tab key="1">Notificaciones</v-tab>
            <v-tab key="2">Usuarios</v-tab>
            <!-- <v-tab key="4">Lecturas libres</v-tab> -->
          <!--   <v-tab key="4">Switch</v-tab> -->
           <!--  <v-tab key="5">
              <span>LIMITE</span>
            </v-tab> -->
          <!--    <v-tab key="6">Programado</v-tab> -->
            <v-tab key="3">Config</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
         <!--    <v-tab-item key="1">
              <TableHistory></TableHistory>
            </v-tab-item> -->
            <v-tab-item key="1">
              <TableNotify></TableNotify>
            </v-tab-item>
            <v-tab-item key="2">
              <TableUser
                :list="this.getUserDevice"
                :device="getQueyDevice"
                :updateList="updateListUsers"
              ></TableUser>
            </v-tab-item>
           <!--  <v-tab-item key="4">
              <TableSwitch></TableSwitch>
            </v-tab-item>
            <v-tab-item key="5">
              <TableLimit></TableLimit>
            </v-tab-item>
            <v-tab-item key="6">
              <TableSchedule
                :list="this.getQueyDevice.scheduleHistory"
              ></TableSchedule>
            </v-tab-item> -->
            <v-tab-item key="3">
              <TableConfig
                :list="this.getQueyDevice.historyConfig"
              ></TableConfig>
            </v-tab-item>
          </v-tabs-items>
        </div>
      </div>
    </div>
    <Limit
      :data="itemObjct"
      :visible="flagLimit"
      @close="flagLimit = false"
    ></Limit>
    <DeleteLimit
      :data="itemObjct"
      :visible="flagDeleteLimit"
      @close="flagDeleteLimit = false"
    ></DeleteLimit>
    <DeleteSchedule
      :data="itemObjct"
      :visible="flagDeleteSchedule"
      @close="flagDeleteSchedule = false"
    ></DeleteSchedule>
    <Schedule
      :data="itemObjct"
      :visible="flagSchedule"
      @close="flagSchedule = false"
    ></Schedule>
    <Connect
      :data="itemObjct"
      :visible="ConnectFlag"
      @close="ConnectFlag = false"
    ></Connect>
    <TakeRead
      :data="itemObjct"
      :visible="TakeFlag"
      @close="TakeFlag = false"
    ></TakeRead>
    <SwitchModal
      :data="itemObjct"
      :visible="SwitchFlag"
      @close="SwitchFlag = false"
    ></SwitchModal>
    <ConfigComp
      :data="itemObjct"
      :visible="configFlag"
      @close="configFlag = false"
    ></ConfigComp>
  </div>
</template>
<script>
import moment from "moment";
import { latLng, Icon } from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup } from "vue2-leaflet";
import { mapGetters, mapActions } from "vuex";
import Nav from "@/components/Nav.vue";
import Snackbar from "@/components/Snackbar.vue";
//import TableHistory from "@/components/device/TableHistory.vue";
import TableNotify from "@/components/device/TableNotify.vue";
import TableUser from "@/components/device/TableUserAssign.vue";
//import TableSwitch from "@/components/device/TableSwitch.vue";
//import TableLimit from "@/components/device/TableLimit.vue";
import Limit from "@/components/device/Limit.vue";
import DeleteLimit from "@/components/device/DeleteLimit.vue";
import Schedule from "@/components/device/Schedule.vue";
//import TableSchedule from "@/components/device/TableSchedule.vue";
import TableConfig from "@/components/device/TableConfig.vue";
import ConfigComp from "@/components/device/Config.vue";
import DeleteSchedule from "@/components/device/DeleteSchedule.vue";
import Connect from "@/components/device/Connect.vue";
import TakeRead from "@/components/device/TakeRead.vue";
import SwitchModal from "@/components/device/Switch.vue";
import LineChartButton from "@/components/device/LineChartButton.vue";
import LineChartButtonYear from "@/components/device/LineChartButtonYear.vue";
import LineChartButtonRange from "@/components/device/LineChartButtonRange.vue";
import LineChart from "@/components/device/LineChart.vue";
import LineChartYear from "@/components/device/LineChartYear.vue";
import LineChartRange from "@/components/device/LineChartRange.vue";
import SkeletonDevice from "@/components/SkeletonDevice.vue";
delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});
export default {
  name: "DeviceID",
  components: {
    Nav,
    Snackbar,
    Connect,
    TakeRead,
   // TableHistory,
    TableNotify,
    TableUser,
    //TableSwitch,
    //TableLimit,
    Limit,
    DeleteLimit,
    Schedule,
    DeleteSchedule,
   // TableSchedule,
    TableConfig,
    ConfigComp,
    LineChartButton,
    LineChartButtonYear,
    LineChartButtonRange,
    LineChart,
    LineChartYear,
    LineChartRange,
    SwitchModal,
    LMap,
    LTileLayer,
    LPopup,
    LMarker,
    SkeletonDevice,
  },
  data() {
    return {
      SwitchFlag: false,
      TakeFlag: false,
      ConnectFlag: false,
      flagLimit: false,
      configFlag: false,
      flagDeleteLimit: false,
      flagDeleteSchedule: false,
      flagChart: 1,
      flagSchedule: false,
      itemObjct: {},
      levelBattery: 100,
      tab: null,
      zoom: 17,
      menu: null,
      total: null,
      date: moment().format("YYYY-MM-DD"),
      menuYear: null,
      dateYear: moment().format("YYYY"),
      menuRange: null,
      dateRange: [
        moment().subtract(7, "day").format("YYYY-MM-DD"),
        moment().format("YYYY-MM-DD"),
      ],
      itemSelect: [
        { id: "1", name: "Lecturas" },
        { id: "2", name: "Notificaciones" },
        { id: "3", name: "Usuarios" },
        { id: "4", name: "Switch" },
        { id: "5", name: "Limite" },
        { id: "6", name: "Programado" },
        { id: "6", name: "Config" },
      ],
      users: [],
      nodes: [],
      counter: [],
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          enabled: true,
          callbacks: {
            label: (tooltipItems) => {
              return `${tooltipItems.yLabel} ${this.getUnit}`;
            },
          },
        },
        scales: {
          yAxes: [
            {
              min: 0,
              ticks: {
                //stepSize: 5,
                callback: (value) => {
                  return `${value} ${this.getUnit}`;
                },
              },
            },
          ],
          x: {
            type: "timeseries",
            time: {
              displayFormats: {
                hour: "HH:mm",
              },
            },
          },
        },
      },
      chartOptionsYear: {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          enabled: true,
          callbacks: {
            label: (tooltipItems) => {
              return `${tooltipItems.yLabel} ${this.getUnit}`;
            },
          },
        },
        scales: {
          yAxes: [
            {
              ticks: {
                suggestedMin: 0,
                suggestedMax: 0.2,
                callback: (value) => {
                  return `${value} ${this.getUnit}`;
                },
              },
            },
          ],
          x: {
            type: "timeseries",
          },
        },
      },
      withPopup: latLng(this.latNum, this.longNum),
      currentCenter: latLng(this.latNum, this.longNum),
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:'&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      showMap: true,
      currentZoom: 30.5,
      showParagraph: false,
    };
  },
  async created() {
    await this.QueryDevice(this.$route.params.id);
    this.users = await this.queryUserDevices(this.$route.params.id);
    let queryStream = {
      _id: this.$route.params.id,
      date: this.date,
    };
    this.actionDataChartDay(queryStream);
    this.actionDataSensorDay(queryStream);
    this.SETupdate();
    this.countState()
   
  },
  methods: {
    ...mapActions([
      "QueryDevice",
      "queryUserDevices",
      "QueryDeviceNode",
      "actionDataSensorDay",
      "actionDataSensorYear",
      "actionDataSensorGeneral",
      "actionDataSensorRange",
      "actionDataChartDay",
      "actionDataChartYear",
      "actionDataChartRange",

    ]),
    lastObject() {
      let lastObj =
        this.getQueyDevice.historyLimit[
          this.getQueyDevice.historyLimit.length - 1
        ];
      if (lastObj != undefined) {
        let units = lastObj.valInit.slice(-3);
        if (lastObj.check != false) {
          return `${lastObj.limit} ${units}`;
        }
        return null;
      }
    },

     async countState(){
        const array = ["short","double","long"]
        for(let i =  0; i < array.length ; i++){
        await this.actionDataSensorGeneral({
           _id: this.getQueyDevice._id,
           data: array[i],
         });
          const info = this.getChartDataSensorGeneral;
           this.counter.push(info)      
         }   
      this.total = this.counter.reduce((total, valorActual) => total + valorActual, 0);
    },
    switchItem(param) {
      this.itemObjct = Object.assign({}, param);
      this.SwitchFlag = true;
    },
    takeItem(param) {
      this.itemObjct = Object.assign({}, param);
      this.TakeFlag = true;
    },
    configItem(param) {
      this.itemObjct = Object.assign({}, param);
      this.configFlag = true;
    },
    connectItem(param) {
      this.itemObjct = Object.assign({}, param);
      this.ConnectFlag = true;
    },
    limitItem(param) {
      this.itemObjct = Object.assign({}, param);
      this.flagLimit = true;
    },
    scheduleItem(param) {
      this.itemObjct = Object.assign({}, param);
      this.flagSchedule = true;
    },
    deleteItem(param) {
      this.itemObjct = Object.assign({}, param);
      this.flagDeleteLimit = true;
    },
    deleteScheduleItem(param) {
      this.itemObjct = Object.assign({}, param);
      this.flagDeleteSchedule = true;
    },
    setChartDay() {
      if(this.getQueyDevice.subTypeService != "Seguridad"){
        this.actionDataChartDay({
        _id: this.getQueyDevice._id,
        date: this.date,
      });
      }
      if(this.getQueyDevice.subTypeService == 'Seguridad'){
        this.actionDataSensorDay({
        _id: this.getQueyDevice._id,
        date: this.date,
      });
      }
      this.flagChart = 1;
    },
    setChartYear() {
      if(this.getQueyDevice.subTypeService !== "Seguridad"){
        this.actionDataChartYear({
        _id: this.getQueyDevice._id,
        date: this.dateYear,
      });
      }
      if(this.getQueyDevice.subTypeService === "Seguridad"){
        this.actionDataSensorYear({
        _id: this.getQueyDevice._id,
        date: this.dateYear,
      });
      } 
      this.flagChart = 2;
    },
    setChartRange() {
      if(this.getQueyDevice.subTypeService !== "Seguridad"){
      this.actionDataChartRange({
        _id: this.getQueyDevice._id,
        date: this.dateRange,
      });
    }
    if(this.getQueyDevice.subTypeService === "Seguridad"){
        this.actionDataSensorRange({
        _id: this.getQueyDevice._id,
        date: this.dateRange,
      });
      } 
      this.flagChart = 3;
    },
    async updateListUsers() {
      this.users = await this.queryUserDevices(this.$route.params.id);
    },
    async SETupdate() {
      if (this.$route.params.id != undefined) {
        let parameter = {
          node: this.getQueyDevice.nodeID,
          station: this.getQueyDevice.station._id,
        };
        await this.QueryDevice(this.$route.params.id);
        this.users = await this.queryUserDevices(this.$route.params.id);
        this.nodes = await this.QueryDeviceNode(parameter);
        if(this.getQueyNode) {
          let sensorBattery = this.getQueyNode.find((device) => device.name.indexOf('BATERIA') >= 0);
          if(sensorBattery) {
            this.levelBattery = (parseFloat(sensorBattery.deviceInfo.Voltage) * 100) / 3.7;
          }
          if(this.getQueyDevice.typeDevice == "Lora-Wan"){
            this.levelBattery = (this.getQueyDevice.BatteryLevel);
          }else {         
            this.levelBattery = (this.getQueyDevice.deviceInfo.BatteryLevel * 100) / 255;
          }
        } else {
          this.levelBattery = (this.getQueyDevice.deviceInfo.BatteryLevel * 100) / 255;
        }
      }
    },
  },
  computed: {
    ...mapGetters([
      "isLogin",
      "getUser",
      "getQueyDevice",
      "getDataChartDay",
      "getDataChartYear",
      "getDataChartRange",
      "getChartDataSensorDay",
      "getChartDataSensorYear",
      "getChartDataSensorGeneral",
      "getChartDataSensorRange",
      "getQueyNode",
      "getAlert",
      "getRol",
      "isMaster",
    ]),
    loadBar() {
      if (this.getQueyDevice != null) {
        return false;
      } else {
        return true;
      }
    },
    dateRangeText() {
      return this.dateRange.join(" ~ ");
    },
    inittahun() {
      let years = [];
      for (var i = 2001; i <= new Date().getFullYear(); i++) {
        let date = String(i);
        years.push(date);
      }
      return years;
    },
    getUnit() {
      let units = "00/00/0000";
      return units;
    },
    takeLastData() {
      let lecturaUltima = this.getQueyDevice.lastData;
      if (lecturaUltima != undefined) {
        return this.getQueyDevice.lastData;
      } else {
        return null;
      }
    },
    getUserDevice() {
      return this.users;
    },
    getDataNow() {
      let array = this.getQueyDevice.dataStream;
      if (array.length > 0 && array != undefined && array != null) {
        let filter = array.slice(-1);
        let res = {
          value: filter[0].v,
          date: moment(filter[0].d).locale("es").fromNow(),
        };
        return res;
      }
      return "-";
    },
    getTakeRead() {
      let array = this.getQueyDevice.lastData;
      if (array.length > 0 && array != undefined && array != null) {
        let filter = array.slice(-1);
        return filter[0].usage;
      }
      return "-";
    },
    getTotalConsumo() {
      let nowValue = this.getQueyDevice.dataValue.val;
      let lastRead = nowValue;
      if (this.getQueyDevice.lastData) {
        lastRead = this.getQueyDevice.lastData.valNow;
      }
      let units = this.getQueyDevice.dataValue.unitVal;
      return `${(nowValue - lastRead).toFixed(3)} ${units}`;
    },
    latNum() {
      let lat = Number(this.getQueyDevice.latitude);
      return lat;
    },
    longNum() {
      let long = Number(this.getQueyDevice.longitude);
      return long;
    },
    coorde() {
      let res = latLng(this.latNum, this.longNum);
      return res;
    },
    getColorStyle() { 
       const val = this.getQueyDevice.dataValue.v
         if(val){
          if(val === "short" || val === "On"  )
          {
            return "red--text text--darken-2"
          }  
          if(val === "double" )
          {
            return "yellow--text text--darken-1"
          }  
          if(val === "long" || val === "Off"  )
          {
            return "indigo--text text--darken-1"
          }  
        }else{
          return "-"
        }
        return "-"
        },
  },
  filters: {
    twoDigit(val) {
      let units = val.split(" ")[1];
      if(units == undefined) units = '';
      return `${parseFloat(val).toFixed(2).toString().replace('.',',')} ${units}`;
    },
    threeDigit(val) {
      let units = val.split(" ")[1];
      if(!units || isNaN(parseFloat(val))) return val;
      return `${parseFloat(val).toFixed(3).toString().replace('.',',')} ${units}`;
    },
    formatDateFrom: (value) => {
      if (value) {
        return moment(value).locale("es").fromNow();
      }
      return "-";
    },
    battery(val) {
      if(isNaN(val)) {
        return '- ';
      }
      return `${parseFloat(val).toFixed(0)}`;
    },
    formatDate: (value) => {
      if (value) {
        return moment(value).locale("es").format("YYYY-MM-DD HH:mm");
      }
      return "-";
    },

    statusValueDevices: (value, valueVal) => {
       const valueS = valueVal.replace(/ /g, "_");
      switch(valueS) {
        case "Sensor_de_Puerta":
        if(value === "Off"){
              value = "Cerrada";
            }
       if(value === "On"){
              value= "Abierta"
            }
          break;
      case "Sensor_de_Humo":
       if(value === "Off"){
            value = "Apagado";
         }           
       if(value === "On"){
              value= "Encendido"
         }
          break;
      case "Boton_de_Panico":
       if(value === "short"){
            value = "¡Alerta!";
          }           
       if(value === "double"){
              value = "¡Advertencia!"
          }
       if(value === "long"){
              value = "¡Informacion!"
          }
          break;
      default:
          console.log("Opción no reconocida");
}
       return value
    
  },
}
};
</script>
<style lang="scss" scoped>
@import "../../assets/scss/base.scss";
.tab_header_select {
  display: none;
  @media #{$phone-down} {
    display: block;
  }
}
.tab_header_custom {
  @media #{$phone-down} {
    display: none;
  }
}
.list_action {
  &:first-child {
    button:hover {
      background-color: $dark-jungle-green;
      color: $light-cyan;
    }
  }
  button.v-btn {
    &.off_line {
      color: $alert;
    }
    &.on_line {
      color: $blue-btn;
    }
  }
}
.ctn_off_data {
  margin-top: 10px;
  span.off_data {
    font-size: 0.85rem;
    text-transform: uppercase;
    padding: 2px 10px;
    border-radius: 4px;
    &.offline {
      background-color: $alert;
      color: $bg-light;
    }
    &.online {
      background-color: $green-btn;
      color: $light-cyan;
    }
  }
}
.style_map {
  display: flex;
  height: 400px;
  z-index: 1;
}
.ctn_bread {
  display: flex;
  flex-direction: column;
  a.bread {
    padding: 5px;
    font-size: 0.9rem;
    color: $color-link;
  }
}
.ctn_chart {
  margin: 20px 0 30px;
  .ctn_flow_chart {
    border: 1px solid #ddd;
    border-radius: 2px;
    overflow: scroll;
    width: 95vw;
    @media #{$tablet-up} {
      overflow: auto;
      width: initial;
    }
    .flow_chart {
      overflow: hidden;
      width: 1200px;
      @media #{$tablet-up} {
        overflow: auto;
        width: initial;
      }
    }
  }
}
</style>
